import { render } from "./ChatMessages.vue?vue&type=template&id=43ca854c&scoped=true&ts=true"
import script from "./ChatMessages.vue?vue&type=script&lang=ts"
export * from "./ChatMessages.vue?vue&type=script&lang=ts"

import "./ChatMessages.vue?vue&type=style&index=0&id=43ca854c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ca854c"]])

export default __exports__